import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const CSRSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        intro_heading: "",
        intro_paragraph: "",
        last_paragraph: "",
    });

    /* ---------------- BLOCKS   ---------------- */
    const [blocks, setBlocks] = useState([
        { block_heading: "", block_content: "" },
    ]);

    /* IMAGES */

    const [csrImages, setCsrImages] = useState({
        1: null,
        2: null,
        3: null,
    });

    const [preview, setPreview] = useState({
        1: null,
        2: null,
        3: null,
    });

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchCSR();
    }, [school_slug]);

    const fetchCSR = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/about_page/get_csr_section/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { section, blocks, images } = res.data.data;

                /* ---------- SECTION ---------- */
                if (section) {
                    setForm({
                        heading: section.heading || "",
                        intro_heading: section.intro_heading || "",
                        intro_paragraph: section.intro_paragraph || "",
                        last_paragraph: section.last_paragraph || ""
                    });
                }
                /* ---------- BLOCKS ---------- */
                if (blocks && blocks.length) {
                    setBlocks(blocks);
                } else {
                    setBlocks([{ block_heading: "", block_content: "" }]);
                }
                
                /* ---------- IMAGES (SLOTS) ---------- */
                const previewState = { 1: null, 2: null, 3: null };
                const imageState = { 1: null, 2: null, 3: null };

                if (images && images.length) {
                    images.forEach((img) => {
                        if (img.sort_order >= 1 && img.sort_order <= 3) {
                        previewState[img.sort_order] =
                            `${baseAPIUrl}assets/images/aboutsec/${img.image_name}`;
                        }
                    });
                }

                setPreview(previewState);
                setCsrImages(imageState);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* HANDLERS */
    const handleChange = e =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const handleBlockChange = (i, e) => {
        const copy = [...blocks];
        copy[i][e.target.name] = e.target.value;
        setBlocks(copy);
    };

    const addBlock = () =>
        setBlocks([...blocks, { block_heading: "", block_content: "" }]);

    const deleteBlock = i => {
        if (blocks.length === 1) return;
        setBlocks(blocks.filter((_, index) => index !== i));
    };

    const handleImageChange = (slot, file) => {
        if (!file) return;

        setCsrImages(prev => ({
            ...prev,
            [slot]: file,
        }));

        setPreview(prev => ({
            ...prev,
            [slot]: URL.createObjectURL(file),
        }));
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));
            formData.append("blocks", JSON.stringify(blocks));

            // SEND IMAGES BY SLOT
            if (csrImages[1]) formData.append("csr_image_1", csrImages[1]);
            if (csrImages[2]) formData.append("csr_image_2", csrImages[2]);
            if (csrImages[3]) formData.append("csr_image_3", csrImages[3]);

            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/add_edit_csr_section`,
                formData,
                { withCredentials: true }
            );
            fetchCSR();
            setMessage(res.data.message);
            scrollToTop();
        } catch (err) {
            console.error(err);
            scrollToTop();
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const removeImage = async (slot) => {
        const confirmDelete = window.confirm(
            `Are you sure you want to delete Image ${slot}? This action cannot be undone.`
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("slot", slot);
            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/delete_csr_image`,
                formData,
                { withCredentials: true }
            );
            if (res.data.status === 1) {
                // ✅ update UI
                setPreview(prev => ({ ...prev, [slot]: null }));
                setCsrImages(prev => ({ ...prev, [slot]: null }));
                scrollToTop();
                setMessage(res.data.msg);
            } else {
                scrollToTop();
                setMessage(res.data.msg || "Failed to delete image");
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to delete image.");
        } finally {
            setLoading(false);
        }

    };

    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">CSR – Our Programs towards the Society section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">About page</li>
                                <li class="breadcrumb-item active">CSR – Our Programs towards the Society section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit CSR – Our Programs towards the Society section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Heading */}
                                        <input type="hidden" name="school_slug" value={school_slug}></input>
                                        <div className="form-group">
                                            <label>Heading of section</label>
                                            <input
                                                type="text"
                                                name="heading"
                                                className="form-control"
                                                placeholder="Heading of section"
                                                value={form.heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Introduction heading */}
                                        <div className="form-group">
                                            <label>Introduction heading</label>
                                            <input
                                                type="text"
                                                name="intro_heading"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Introduction heading"
                                                value={form.intro_heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Introduction paragraph */}
                                        <div className="form-group">
                                            <label>Introduction paragraph</label>
                                            <textarea
                                                name="intro_paragraph"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Introduction paragraph`}
                                                value={form.intro_paragraph}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Content blocks */}
                                        <div className="form-group">
                                            <label>Content Blocks</label>
                                            {blocks.map((b, i) => (
                                                <div key={i} className="border p-2 mb-2">
                                                    <input className="form-control mb-1"
                                                        name="block_heading"
                                                        placeholder="Block Heading"
                                                        value={b.block_heading}
                                                        onChange={e => handleBlockChange(i, e)}
                                                    />
                                                    <textarea className="form-control"
                                                        rows="3"
                                                        name="block_content"
                                                        placeholder="Block Content"
                                                        value={b.block_content}
                                                        onChange={e => handleBlockChange(i, e)}
                                                    />
                                                    <button type="button"
                                                        className="btn btn-danger btn-sm mt-2"
                                                        disabled={blocks.length === 1}
                                                        onClick={() => deleteBlock(i)}
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            ))}

                                            <button className="btn btn-success mt-3" type="button" onClick={addBlock}>
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* Last paragraph */}
                                        <div className="form-group">
                                            <label>Last paragraph</label>
                                            <textarea
                                                name="last_paragraph"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Last paragraph`}
                                                value={form.last_paragraph}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* CSR images */}
                                        <div className="form-group">
                                            <label>CSR images (Exactly 3)</label>
                                            {[1, 2, 3].map(slot => (
                                            <div key={slot} className="mb-3 border p-2">
                                                <label>Image {slot}</label>

                                                {preview[slot] ? (
                                                    <>
                                                        <img
                                                            src={preview[slot]}
                                                            className="img-fluid mb-2"
                                                            style={{ maxWidth: "150px", display: "block", marginBottom: "8px" }}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage(slot)}   // 👈 API call here
                                                            style={{marginBottom: "10px" }}
                                                        >
                                                            Remove Image
                                                        </button>
                                                    </>
                                                ) : null}

                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleImageChange(slot, e.target.files[0])}
                                                />
                                            </div>
                                            ))}
                                        </div>

                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default CSRSection;